import React from 'react'
import Header from './header'
import Footer from './footer'
import GetQuote from './getquote'

const Layout = (props) => {
  const { children, home, state, blog, title, captions } = props
  return(
    <React.Fragment>
      <Header {...props}>
        {
          // home ?
          // <div className="row justify-content-center text-center">
          //   <div className="col col-lg-8 text-white">
          //     <div class="banner-slogan my-2">
          //       test Get the next generation of insurance now. Powered by AI, data transparency, and safe driving - we’re Omnidya 123. 
          //     </div>
          //   </div>
          //   <div className="w-100"></div>
          //   <div className="col col-lg-4">
          //     <div class="banner-caption my-2 text-white">
          //       Join the fastest growing auto insurance company in the West (and soon, the whole U.S.)
          //     </div>
          //     <div className="mb-5">
          //       <GetQuote btnLabel="Sign Up and Save" />
          //     </div>
          //   </div>
          // </div>
          // :
          // state ?
          // <React.Fragment>
          //   <div className="text-center text-white my-5">
          //     <div className="cityTitle mb-1">
          //       {title}
          //     </div>
          //     <div className="header-slogan mb-5">
          //       {captions}
          //     </div>
          //   </div>
          //   <GetQuote btnLabel="Get a Quote" />
          // </React.Fragment>
          // :
          blog ?
          <div className="text-center text-white py-3">
            <div className="banner-title mb-1">
              {title}
            </div>
            <div class="banner-caption">
              {captions}
            </div>
          </div>
          :
          !home ?
          <div className="text-center text-white">
            {/* <div className="banner-title pb-1">
              {title}
            </div> */}
            <div class="banner-page-caption">
              {captions}
            </div>
          </div>
          :
          ""
        }
      </Header>
      <React.Fragment>
        {children}
      </React.Fragment>
      <Footer />
    </React.Fragment>
  )
}

export default Layout;
